import React, { FC } from 'react'
import SmallContainer from '../ui/layout/SmallContainer'
import { Heading, Text } from '../ui/typography'
import * as styles from './styles'

type HeroTitleProps = {
  title: string
  description?: string
  visible: boolean
}

export const HeroTitle: FC<HeroTitleProps> = ({ title, description, visible }) => {
  return (
    <SmallContainer className={styles.container}>
      <Heading
        variant="h2"
        as="h1"
        className={styles.title}
        data-visibility={visible ? 'visible' : 'hidden'}
      >
        {title}
      </Heading>
      {description && (
        <Text
          variant="bodyLargeSpecial"
          color="shade500"
          className={styles.text}
          data-visibility={visible ? 'visible' : 'hidden'}
        >
          {description}
        </Text>
      )}
    </SmallContainer>
  )
}
